import { type FC } from 'react';
import cn from 'classnames';

import { getImageFromMapObj } from '@/assets/img/imageMap';
import { getImage } from '@/common/lib/images';
import { toShortNumFormat } from '@/common/lib/toShortNumFormat';
import { Picture } from '@/components/ui/Picture/Picture';

interface LevelUpRewardItemProps {
  itemName: string;
  value: number;
}

const LevelUpRewardItem: FC<LevelUpRewardItemProps> = ({ itemName, value }) => {
  const walletOrTicketImage = getImageFromMapObj(itemName);
  const gameItemImage = getImage({ name: itemName, field: 'icon' });

  return (
    <li>
      <div
        className={cn(
          'flex',
          itemName === 'tgem' && 'gradient purple-gradient',
          itemName === 'cash' && 'gradient green-gradient',
        )}
      >
        <Picture
          className="w-8"
          img={walletOrTicketImage.png || gameItemImage?.img}
          webp={walletOrTicketImage.webp || gameItemImage?.webp}
          alt={itemName}
        />
      </div>
      {toShortNumFormat(value)}
    </li>
  );
};

export { LevelUpRewardItem };
